import React, { FC, useContext, useState } from 'react';
import { ModalHeader } from '../../components/form/ModalHeader';
import { useTranslation } from 'react-i18next';
import { Form, Modal } from 'react-bootstrap';
import { DashboardDialogsAssetsSelect } from './DashboardDialogsAssetsSelect';
import { DashboardDialogsCustomerSelect } from './DashboardDialogsCustomerSelect';
import { DashboardDialogsSiteSelect } from './DashboardDialogsSiteSelect';
import { FormModalFooter } from '../../components/form/FormModalFooter';
import { DashboardDialogAssetsRequestPayloadFactory } from './DashboardDialogAssetsRequestPayloadFactory';
import { DashboardDialogSelectOption } from './types/DashboardDialogSelectOption';
import toast from 'react-hot-toast';
import { api } from '../../functions/api';
import { ApiPath } from '../../api/ApiPath';
import ModalContext from 'react-bootstrap/ModalContext';
import { useSavingToastMessages } from '../../hooks/useSavingToastMessages';
import { FormSelectOption } from '../../components/form/FormSelect';
import { Site } from '../../sites/dto/Site';

export const DashboardIssueDialog: FC = () => {
  const { t } = useTranslation();
  const [assets, setAssets] = useState<DashboardDialogSelectOption[]>([]);
  const [customerId, setCustomerId] = useState<number | null>(null);
  const [sourceSite, setSourceSite] = useState<FormSelectOption<Site> | null>(null);
  const { onHide } = useContext(ModalContext);
  const messages = useSavingToastMessages();

  const canSubmit = assets.length > 0 && customerId && sourceSite;

  return (
    <>
      <ModalHeader>{t('Issue assets')}</ModalHeader>

      <form
        onSubmit={async (event) => {
          event.preventDefault();

          if (canSubmit) {
            const payload = new DashboardDialogAssetsRequestPayloadFactory(assets).getRequestPayload();

            await toast.promise(
              api({
                method: 'put',
                url: ApiPath.DashboardUnassignedAssets,
                data: {
                  ...payload,
                  customerId,
                  sourceSiteId: sourceSite.value.id,
                },
              }),
              messages,
            );

            onHide();
          }
        }}
      >
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>{t('From site')}</Form.Label>
            <DashboardDialogsSiteSelect
              onChange={setSourceSite}
              value={sourceSite}
              placeholder={t('Select source site').toString()}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t('Assets to issue')}</Form.Label>
            <DashboardDialogsAssetsSelect onChange={setAssets} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t('Customer')}</Form.Label>
            <DashboardDialogsCustomerSelect onChange={(option) => setCustomerId(option.value.id)} />
          </Form.Group>
        </Modal.Body>

        <FormModalFooter disabled={!canSubmit} />
      </form>
    </>
  );
};
